import styled from 'styled-components'

export const PaginationWrapper = styled.div`
    max-width: 300px;
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
`
